import React from "react";
import { useIonModal } from "@ionic/react";
import { useBotsStore } from "../stores/bots.store";
import { useUsersStore } from "../stores/users.store";
import BotListItem from "./BotListItem";
import { Bot } from "../types/bot.type";
import ConfirmationPage from "../pages/Confirmation";

interface FavouriteBotsProps {
  onSelect: (bot: Bot) => void;
  selectedBots: string[];
  multiples?: boolean;
}

const FavouriteBots: React.FC<FavouriteBotsProps> = ({
  onSelect,
  selectedBots,
  multiples = false
}) => {
  console.log("selectedBots", selectedBots);
  const favouriteBots: any[] = useUsersStore(state =>
    state?.userFavourites?.sort((a: any, b: any) =>
      a.profit > b.profit ? 1 : -1
    )
  );
  const favouriteBotIds = favouriteBots?.map((strat: any) => strat.botId);
  const bots = useBotsStore(state =>
    state.bots?.filter((bot: any) => favouriteBotIds?.includes(bot.id))
  );
  const [selectedBot, setSelectedBot] = React.useState<Bot | null>(null);
  const [presentConfirm, dismissConfirm] = useIonModal(ConfirmationPage, {
    onDismiss: (confirm: boolean) => {
      if (confirm && selectedBot) {
        onSelect(selectedBot);
      }
      dismissConfirm();
    },
    lottieAnimation: "thinkingAnimation",
    title: "Confirm Strategy Replacement",
    confirmText: "Confirm",
    contentHtml: `
    <div class="p-8">
      Are you sure you want to replace the existing strategy with this ${selectedBot?.name} strategy?
    </div>
    `,
    cssClass: "transparent-modal"
  });

  const handleBotSelect = (bot: Bot) => {
    if (!multiples) {
      setSelectedBot(bot);
      presentConfirm();
    } else {
      onSelect(bot);
    }
  };

  return (
    <div className="mt-4 p-2 rounded-xl bg-primary-90">
      {bots.map((bot: any, index: number) => (
        <BotListItem
          key={bot.id}
          bot={bot}
          index={index}
          hideEarnings
          selectable
          onSelect={() => handleBotSelect(bot)}
          selected={selectedBots.includes(bot?.id)}
        />
      ))}
    </div>
  );
};

export default FavouriteBots;
